import { sendRequest } from "@infrastructure/api/authApiClient";
import { LoginRequest } from "@features/auth/types/loginRequest";
import { AuthResponse, UserEligibilityResponse } from "@features/auth/types/authResponse";
import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import { RegisterRequest } from "../types/registerRequest";
import { ForgotPasswordRequest } from "../types/forgotPassword";
import { ResetPasswordRequest } from "../types/resetPassword";

export const register = async (request: RegisterRequest): Promise<ApiResponse<ApiMessageResponse>> => {
    const response = await sendRequest<RegisterRequest, ApiMessageResponse>('POST', '/auth/signup', request);
    return response;
};

export const login = async (request: LoginRequest): Promise<ApiResponse<AuthResponse>> => {
    const response = await sendRequest<LoginRequest, AuthResponse>('POST', '/auth/login', request);
    return response;
};

export const refreshToken = async (): Promise<ApiResponse<AuthResponse>> => {
    const response = await sendRequest<any, AuthResponse>('POST', '/auth/refresh');
    return response;
};

export const logout = async (): Promise<ApiResponse<ApiMessageResponse>> => {
    const response = await sendRequest<any, ApiMessageResponse>('POST', '/auth/logout');
    return response;
};

export const forgotPassword = async (request: ForgotPasswordRequest): Promise<ApiResponse<ApiMessageResponse>> => {
    const response = await sendRequest<ForgotPasswordRequest, ApiMessageResponse>('POST', '/auth/password-reset/request', request);
    return response;
};

export const resetPassword = async (request: ResetPasswordRequest): Promise<ApiResponse<ApiMessageResponse>> => {
    const response = await sendRequest<ResetPasswordRequest, ApiMessageResponse>('POST', '/auth/password-reset/confirm', request);
    return response;
};

export const checkUserEligibility = async (email: string): Promise<ApiResponse<UserEligibilityResponse>> => {
    const response = await sendRequest<{ email: string }, UserEligibilityResponse>('POST', '/auth/user-eligibility', { email });
    return response;
};
